import { useMemo } from "react";
import { SnowplowTracker } from "~/utils/snowplow/snowplow_tracker";

export const useSnowplowTracker = () => useMemo(() => new SnowplowTracker(), []);
